<script setup lang="ts">
import { LucideTrophy, LucideLoader2 } from 'lucide-vue-next'
import type { IQuiz } from './types'

defineProps<{
  quiz: IQuiz
  isLoading: boolean
  hasActiveAttempt: boolean
}>()

const emit = defineEmits<{
  start: []
  restart: []
  resume: []
}>()
</script>

<template>
  <div class="overflow-hidden rounded-lg bg-white animate-[fadeIn_0.3s_ease-out]">
    <div class="space-y-3 p-6">
      <div class="flex items-center gap-3 text-sm text-gray-600">
        <span class="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full border border-green-200 bg-green-50 text-green-600">
          <LucideTrophy class="h-4 w-4" />
        </span>
        {{ $t('widget.quiz.start.results_breakdown') }}
      </div>
    </div>

    <div class="border-t border-gray-100 px-6 py-5">
      <div v-if="isLoading" class="flex items-center justify-center py-1">
        <LucideLoader2 class="h-6 w-6 animate-spin text-gray-500" />
      </div>
      <template v-else-if="hasActiveAttempt">
        <p class="mb-3 text-center text-sm text-gray-500">{{ $t('widget.quiz.resume.subtitle') }}</p>
        <div class="flex flex-col gap-2">
          <Button class="w-full" variant="blue" @click="emit('resume')">
            {{ $t('widget.quiz.resume.continue') }}
          </Button>
          <Button class="w-full" variant="outline-gray" @click="emit('restart')">
            {{ $t('widget.quiz.resume.restart') }}
          </Button>
        </div>
      </template>
      <Button v-else class="w-full" variant="blue" @click="emit('start')">
        {{ $t('widget.quiz.start.begin') }}
      </Button>
    </div>
  </div>
</template>
